angular.module('impactx.controlstructure').service('BasketAdHocControlStructureService', [
    'TranslationService',
    '$mdPanel',
    BasketAdHocControlStructureService
]);

function BasketAdHocControlStructureService(TranslationService, $mdPanel) {
    var self = this;

    self.openPanel = function (event, data, trns, closePanelFunc) {
        var locals = {
            trns: {
                title: trns.createNew + " " + data.label,
                save: TranslationService.get('save'),
                name: trns.name,
                number: trns.number,
                subNumber: trns.subNumber
            },
            type: data.identifier
        };

        $mdPanel.open({
            id: 'control-panel-' + data.identifier,
            attachTo: angular.element(document.body),
            templateUrl: 'shared/control/templates/create-control-panel.tmpl.html',
            trapFocus: true,
            zIndex: 100,
            propagateContainerEvents: true,
            clickOutsideToClose: true,
            controller: 'CreateControlPanelCtrl',
            controllerAs: 'createControlPanelCtrl',
            event: event,
            locals: {
                locals: locals
            },
            panelClass: 'menu-panel-container',
            position: $mdPanel.newPanelPosition()
                .relativeTo(angular.element(event.target))
                .addPanelPosition(
                    $mdPanel.xPosition.ALIGN_END,
                    $mdPanel.yPosition.BELOW,
                    $mdPanel.absPosition.LEFT
                ),
            openFrom: event,
            onCloseSuccess: closePanelFunc
        });

    };

    return {
        openPanel: self.openPanel
    };
}